
const state = {
    org: null
}

const actions = {
    // async fetchUser(state, id_token) {
    //   await axios
    //     .get(process.env.VUE_APP_API + "/api/v1/ping", {headers: {'Authorization': 'Bearer ' + id_token}})
    //     .then(response => { 
    //       state.commit('setName', response.data)
    //     }).catch(error => {
    //     })
    // }
}

const mutations = {
    setOrg(state, org) {
      state.org = org
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}